import request from '@/router/axios';
export const getList = (data) => {
    return request({
        url: '/api/produce/stock-management/select/stockSummaryQuery',
        method: 'post',
        data
    })
}
export const exportExcel = (data) => {
    return request({
        url: '/api/produce/stock-management/export/stock-summary-query',
        method: 'post',
        data,
        responseType: 'blob'
    })
}
